import React from 'react';
import Magnifier from 'react-magnifier';

class CarImage extends React.Component {

   render() {
      const imageUrl = this.props.imageUrl;
      return (
         <div className={'car-view-background'}>
            <div className={'car-view-rims'}>
               {this.props.base64img ?
                  <Magnifier style={{'position': 'relative'}}
                             mgWidth={220} mgHeight={220} mgTouchOffsetX={15} mgTouchOffsetY={0}
                             zoomFactor={0.9} src={imageUrl}
                             zoomImgSrc={this.props.base64img}
                             className={'car-view-image'}
                             mgShape='square'/>
                  :
                  <img src={imageUrl}
                       className={'car-view-image'}/>
               }
            </div>
         </div>
      );
   }
}

CarImage.serverFetch = '';
const mapStateToProps = state => ({});

export default CarImage;
